<template>
  <b-modal
    title="Permitir dispositivo"
    size="md"
    id="modal_add_device"
    no-close-on-backdrop
    no-close-on-esc
    :busy="loading"
    hide-footer
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <b-form @submit.prevent="evOnSubmit">
      <b-row>
        <b-col>
          <LabelRequiredField label="Nome" />
          <b-input type="text" ref="autofocus" v-model="name"></b-input>
          <small class="form-text text-muted">Exemplo: Computador Sala 1</small>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <LabelRequiredField label="Código" />
          <b-input type="text" v-model="code"></b-input>
        </b-col>
      </b-row>
      <WarningRequiredFields />
      <ErrorsMessages :errors="errors" />
      <b-row align-h="between">
        <b-col cols="auto">
          <v-btn class="v-primary" @click="$bvModal.hide('modal_add_device')">
            <span class="fa fa-arrow-left"></span>
            Voltar
          </v-btn>
        </b-col>
        <b-col cols="auto">
          <v-btn type="submit" class="v-success">
            <span class="fa fa-check"></span>
            Salvar
          </v-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../../components/ErrorsMessages";
import WarningRequiredFields from "../../components/WarningRequiredFields";
import LabelRequiredField from "../../components/LabelRequiredField";
import api from "../../../services/api";
import toast from "../../../components/ToastNotification";

export default {
  name: "AddDevice",

  components: {
    ErrorsMessages,
    WarningRequiredFields,
    LabelRequiredField,
  },

  data() {
    return {
      errors: [],
      loading: false,

      rest_home_id: "",

      name: "",
      code: "",
    };
  },

  created() {
    const { rest_home_id } = this.$attrs;
    this.rest_home_id = rest_home_id;
  },

  methods: {
    async evOnShow() {
      this.errors = [];
      this.loading = false;
      this.name = "";
      this.code = "";
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {},

    async evOnSubmit() {
      try {
        this.loading = true;

        const data = {
          rest_home_id: this.rest_home_id,
          name: this.name,
          code: this.code,
        };
        const response = await api.post("/admin/rest-home/device", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$emit("created");
          this.$bvModal.hide("modal_add_device");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>